import { getAnalysisReportsRequest } from "../../requests/analysisReports";
export const types = {
  GET_DASHBOARD_REPORTS_REQUEST: 'GET_DASHBOARD_REPORTS_REQUEST',
  GET_DASHBOARD_REPORTS_SUCCESS: 'GET_DASHBOARD_REPORTS_SUCCESS',
  GET_DASHBOARD_REPORTS_FAILURE: 'GET_DASHBOARD_REPORTS_FAILURE'
}

export const getDashboardReports = ({ startDate, endDate, id, type = 'all', loginState = 3 }) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_DASHBOARD_REPORTS_REQUEST
    })
    getAnalysisReportsRequest({
      startDate,
      endDate,
      id,
      type,
      loginState
    })
      .then(response => {
        dispatch({
          type: types.GET_DASHBOARD_REPORTS_SUCCESS,
          payload: response.data ? response.data.analysisData : null
        })
      })
      .catch(error => {
        dispatch({
          type: types.GET_DASHBOARD_REPORTS_FAILURE
        })
      })
  }
}